<div class="item-list" [attr.aria-busy]="loading || null">
  @if (loading) {
    <div class="item-list__head placeholder-glow">
      <span class="placeholder item-list__skeleton-line item-list__skeleton-line--count"></span>
    </div>
    <div class="item-list__body placeholder-glow">
      @for (row of skeletonRows; track row) {
        <div class="item-list__skeleton">
          <span class="placeholder item-list__skeleton-dot"></span>
          <span class="placeholder item-list__skeleton-icon"></span>
          <div class="item-list__skeleton-body">
            <span class="placeholder item-list__skeleton-line item-list__skeleton-line--title"></span>
            <span class="placeholder item-list__skeleton-line item-list__skeleton-line--meta"></span>
          </div>
          <span class="placeholder item-list__skeleton-line item-list__skeleton-line--trailing"></span>
        </div>
      }
    </div>
  } @else if (empty) {
    <div class="item-list__empty">
      <ng-content select="[empty]"></ng-content>
    </div>
  } @else {
    @if (countLabel || hintLabel) {
      <div class="item-list__head">
        <span class="item-list__count typo-label-large">{{ countLabel }}</span>
        <span class="item-list__hint typo-body-small">{{ hintLabel }}</span>
      </div>
    }
    <div class="item-list__body">
      <ng-content></ng-content>
    </div>
  }
</div>
